module.exports = __webpack_public_path__ + "img/infographics_3.a6390489.png";